import React from "react";

const WhatsAppButton = () => {
  const phoneNumber = "971561184114"; // 🔴 replace with your WhatsApp number
  const message = "Hello, I am interested in your service.";

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
};

export default WhatsAppButton;
